(function () {
  const contentDebug = false;

  // About Us Elements
  const aboutUs = document.querySelector('[data-au-status]');
  const intro = document.querySelector('[data-intro-status]');
  const heroSection = document.querySelector('.animated-hero.about-us-intro');
  const content = document.querySelector('#aui-button-content');
  const reviewsContainer = document.querySelector(
    '.animated-hero-reviews.aui-reviews'
  );
  const reviewImages = document.querySelectorAll(
    '.animated-hero-reviews.aui-reviews img'
  );

  // Animation state
  let reviewsAnimationStarted = false;

  const resetButton = document.querySelector('[data-reset-button]');
  const resetContent = document.querySelector('[data-reset-status]');
  const backButton = document.querySelector('.k-au-menu--back');
  let backedState = false;

  const aboutUsContent = document.querySelector('[data-au-content]');
  const hiddenClass = 'k-au-slider-menu--hidden';
  const hiddenDom = document.querySelectorAll(`.${hiddenClass}`);

  const mobileSelect = document.querySelector('[data-au-s-option]');
  const mobileOptionsWrapper = document.querySelector('[data-au-options]');

  const startReviewsAnimation = () => {
    if (reviewsAnimationStarted) return;
    reviewsAnimationStarted = true;

    if (reviewsContainer) {
      reviewsContainer.classList.add('reviews-animate');
    }

    reviewImages.forEach((img, index) => {
      const hasLeftClass = img.classList.contains('k-au-img--left');
      const hasRightClass = img.classList.contains('k-au-img--right');

      if (hasLeftClass || hasRightClass) {
        const computedStyle = window.getComputedStyle(img);
        const animationDelay = computedStyle.animationDelay;

        let delayMs = 0;
        if (animationDelay && animationDelay !== '0s') {
          delayMs = parseFloat(animationDelay) * 1000;
        }

        setTimeout(() => {
          img.classList.add('animate-now');
        }, delayMs);
      }
    });

    const isMobile = window.innerWidth <= 768;
    const contentDelay = isMobile ? 2000 : 4000;

setTimeout(() => {
  const textContainer = heroSection.querySelector('.text-container');
      if (textContainer) textContainer.classList.add('show-animation');

      if (content) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            content.classList.add('show-content');
          });
        });
      }
    }, 2000);
  };

  const createReviewsObserver = () => {
    const observerOptions = {
      root: null,
      rootMargin: '-15% 0px -15% 0px',
      threshold: 1.0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !reviewsAnimationStarted) {
           setTimeout(() => {
                startReviewsAnimation();
            }, 800);
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    if (reviewsContainer) {
      observer.observe(reviewsContainer);
    } else if (heroSection) {
      observer.observe(heroSection);
    }

    return observer;
  };

  const resetReviewsAnimation = () => {
    reviewsAnimationStarted = false;

    if (reviewsContainer) {
      reviewsContainer.classList.remove('reviews-animate');
    }

    reviewImages.forEach((img) => {
      img.classList.remove('animate-now');
    });

    if (heroSection) {
      heroSection.classList.remove('content-visible');
    }
    if (content) {
      content.classList.remove('show-content');
    }
  };

  let reviewsObserver;

  const initReviewsObserver = () => {
    if (!contentDebug) {
      reviewsObserver = createReviewsObserver();
    } else {
      setTimeout(startReviewsAnimation, 1000);
    }
  };

  const toggleMenu = () => {
    if (!mobileSelect || !mobileOptionsWrapper) return;
    const currentStatus =
      mobileSelect.dataset.status === 'active' ? 'hidden' : 'active';
    mobileSelect.dataset.status = currentStatus;
    mobileOptionsWrapper.dataset.status = currentStatus;
  };

  const initMenu = () => {
    if (!mobileSelect) return;
    mobileSelect.addEventListener('click', (e) => {
      toggleMenu();
    });
  };

  const menuOptions = (slider) => {
    const sliderPosition = slider.dataset.auSlider;
    const currentOption = document.querySelectorAll(
      `[data-au-menu-button="${sliderPosition}"]`
    );

    if (currentOption.length) {
      currentOption.forEach((option) => {
        option.addEventListener('click', (e) => {
          document.querySelector('body').scrollTo({ top: 0 });
          if (aboutUsContent) {
            const targetElement = document.querySelector(
              `#${option.dataset.toSlide?.split('#')[1]}`
            );
            if (targetElement) {
              aboutUsContent.scrollTo({
                top: targetElement.offsetTop - aboutUsContent.offsetTop + 100,
                behavior: 'smooth',
              });
            }
          }

          if (option.dataset.auOption != undefined) {
            toggleMenu();
          }
        });
      });
    }
  };

  const setSlideMaxHeight = (swiper, slider) => {
    swiper.slides.forEach((slide) => {
      slide.style.height = 'auto';
    });
    const heights = [];
    swiper.slides.forEach((slide) => {
      heights.push(slide.clientHeight);
    });
    const maxHeight = Math.max(...heights);
    swiper.slides.forEach((slide) => {
      slide.style.height = maxHeight + 'px';
    });
  };

  const toggleMenuHidden = () => {
    setTimeout(() => {
      hiddenDom.forEach((dom) => {
        dom.classList.toggle(hiddenClass);
      });
    }, 500);
  };

  const initContent = () => {
    if (!aboutUs) return;

    const sliderInSlider = document.querySelectorAll('[data-au-slider]');
    aboutUs.dataset.auStatus = 'content';

    window.swipers = [];
    sliderInSlider.forEach((slider) => {
      var swiper2 = new Swiper(slider, {
        slidesPerView: 1.2,
        observer: true,
        breakpoints: {
          991: {
            slidesPerView: 2,
          },
        },
        on: {
          afterInit: function (swiper) {
            setTimeout(() => {
              setSlideMaxHeight(swiper, slider);
            }, 500);
          },
          breakpoint: function (swiper) {
            setTimeout(() => {
              setSlideMaxHeight(swiper, slider, true);
            }, 500);
          },
          resize: function (swiper) {
            let resize;
            clearTimeout(resize);
            resize = setTimeout(() => {
              setSlideMaxHeight(swiper, slider, true);
            }, 500);
          },
        },
      });

      const dragText = slider.querySelector('.k-au-drag-text');
      if (dragText) {
        dragText.addEventListener('click', () => {
          swiper2.slideNext();
        });
      }

      menuOptions(slider);

      const bannerSlider = slider.querySelector('.k-slider__carrousel');
      if (bannerSlider) {
        const bannerSwiper = new Swiper(bannerSlider, {
          slidesPerView: 1.2,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            991: {
              slidesPerView: 3,
            },
          },
        });
      }

      window.swipers.push(swiper2);
    });
  };

  if (resetButton) {
    resetButton.addEventListener('click', () => {
      if (!aboutUs || !intro || !resetContent) return;

      aboutUs.dataset.auStatus = 'transition';
      intro.dataset.introStatus = 'hidden';
      resetContent.dataset.resetStatus = 'active';

      setTimeout(() => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }, 500);

      setTimeout(() => {
        intro.style.display = 'none';
        resetContent.style.display = 'none';

        if (aboutUsContent) {
          aboutUsContent.dataset.auContent = 'active';
          aboutUsContent.setAttribute('aria-hidden', 'false');
          aboutUsContent.focus();
        }
        toggleMenuHidden();

        if (backedState) {
          aboutUs.dataset.auStatus = 'content';
        } else {
          initContent();
          initMenu();
        }
      }, 3500);
    });
  }

  if (backButton) {
    backButton.addEventListener('click', () => {
      if (!aboutUs || !aboutUsContent || !intro || !resetContent) return;

      backedState = true;
      aboutUs.dataset.auStatus = 'intro';
      aboutUsContent.dataset.auContent = 'hidden';
      intro.style.display = 'block';
      intro.dataset.introStatus = 'active';
      resetContent.style.display = 'block';
      resetContent.dataset.resetStatus = 'hidden';
      toggleMenuHidden();

      resetReviewsAnimation();

      setTimeout(() => {
        initReviewsObserver();
      }, 100);
    });
  }

  const startTimer = () => {
    const timer = document.querySelector('[data-countup]');
    if (!timer) return;

    const timerText = timer.querySelector('p');
    if (!timerText) return;

    const goal = 120000000000;
    let count = 0;

    const timerInterval = setInterval(() => {
      if (count >= goal) {
        clearInterval(timerInterval);
      } else {
        count = count + 3805;
        let newCount =
          Number(goal.toString().length) - Number(count.toString().length);
        let newCountString = count.toString();

        for (let i = 0; i < newCount; i++) {
          newCountString = `0${newCountString}`;
        }
        timerText.innerHTML = newCountString;
      }
    }, 1000);
  };

  const init = () => {

    initReviewsObserver();

    startTimer();

    if (contentDebug && aboutUsContent && intro && resetContent) {
      aboutUsContent.dataset.auContent = 'active';
      intro.style.display = 'none';
      resetContent.style.display = 'none';
      toggleMenuHidden();
      initContent();
      initMenu();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  let oldScroll = 0;
  const downArrow = document.querySelector('.k-au-content .k-au-down-arrow');
  let downArrowPosition = 0;

  if (aboutUsContent && downArrow) {
    aboutUsContent.addEventListener('scroll', (e) => {
      const newScroll = aboutUsContent.scrollTop;
      const scrollPos = aboutUsContent.scrollTop;

      const slide1 = document.querySelector('#slider-1');
      const slide2 = document.querySelector('#slider-2');
      const slide3 = document.querySelector('#slider-3');

      if (!slide1 || !slide2 || !slide3) return;

      if (scrollPos < slide2.offsetTop) {
        downArrowPosition = 1;
      } else if (scrollPos < slide3.offsetTop - 100) {
        downArrowPosition = 2;
      } else if (scrollPos >= slide3.offsetTop - 250) {
        downArrowPosition = 3;
      }

      if (scrollPos >= slide3.offsetTop - 250) {
        if (window.innerWidth <= 768) {
          downArrow.style.display = 'none';
        }
      } else {
        if (window.innerWidth <= 768) {
          downArrow.style = '';
        }
      }

      if (oldScroll - newScroll > 0) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }

      const parentClass =
        window.innerWidth <= 768 ? '.k-au-menu__select' : '.k-au-menu__content';
      const selectToScroll = document.querySelector(
        `${parentClass} [data-au-menu-button="${downArrowPosition}"]`
      );

      if (selectToScroll && mobileSelect) {
        if (window.innerWidth <= 768) {
          const img = selectToScroll.querySelector('img');
          const p = selectToScroll.querySelector('p');
          if (img && p) {
            const mobileImg = mobileSelect.querySelector('img');
            const mobileP = mobileSelect.querySelector('p');
            if (mobileImg && mobileP) {
              mobileImg.src = img.src;
              mobileP.innerHTML = p.innerHTML;
            }
          }
        } else {
          const opts = document.querySelectorAll(
            `${parentClass} [data-au-menu-button]`
          );
          opts.forEach((op) => (op.dataset.status = ''));
          selectToScroll.dataset.status = 'active';
        }
      }

      oldScroll = newScroll;
    });

    if (downArrow) {
      downArrow.addEventListener('click', () => {
        if (window.innerWidth <= 768) {
          const scrollPos = aboutUsContent.scrollTop;
          const slide1 = document.querySelector('#slider-1');
          const slide2 = document.querySelector('#slider-2');
          const slide3 = document.querySelector('#slider-3');

          if (!slide1 || !slide2 || !slide3) return;

          if (scrollPos >= slide1.offsetTop && scrollPos < slide2.offsetTop) {
            downArrowPosition = 2;
          } else if (
            scrollPos >= slide2.offsetTop &&
            scrollPos < slide3.offsetTop
          ) {
            downArrowPosition = 3;
          }

          const selectToScroll = document.querySelector(
            `[data-au-menu-button="${downArrowPosition}"]`
          );
          if (selectToScroll) {
            selectToScroll.click();
          }
        }
      });
    }
  }

  const shareHolders = document.querySelector('#slider-3');

  if (shareHolders) {
    let transformCoinPosition = 0;
    let lastScrollPos = 0;
    let intersecting = false;
    let coinsScrolled = false;

    const checkCoinIntersection = () => {
      const element1 = document.querySelector(
        '.k-slider__decorations[data-type="3"]'
      );
      const element2 = document.querySelector('#slider-3 .k-slider__images');

      if (!element1 || !element2) return false;

      const rect1 = element1.getBoundingClientRect();
      const rect2 = element2.getBoundingClientRect();

      return !(rect1.top < rect2.top);
    };

    const coinObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        const elementsToScroll = shareHolders.querySelectorAll(
          '.k-slider__decorations'
        );

        const dropInterval = setInterval(() => {
          elementsToScroll.forEach((element, i) => {
            if (checkCoinIntersection()) {
              element.style.opacity = '0';
              clearInterval(dropInterval);
            } else {
              if (!coinsScrolled) {
                element.style.marginTop = '600px';
              } else if (i === elementsToScroll.length - 1) {
                coinsScrolled = true;
              }
            }
          });
        }, 1000);
      } else {
        intersecting = false;
      }
    });

    coinObserver.observe(shareHolders);
  }
})();
